const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const clientConfirmationAllFields = [
  {
    id: "name",
    label: "Full Name",
    placeHolder: "Enter full name",
    type: "text",
    isRequired: true,
    md: 4.5,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    editReadOnly: true,
  },
  {
    id: "referrerId",
    label: "Referrer",
    placeHolder: "Select",
    type: "select",
    options: [],
    md: 4.5,
  },
  {
    id: "phone",
    label: "Phone Number",
    placeHolder: "Enter phone number",
    type: "text",
    md: 4.5,
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "email",
    label: "Email",
    placeHolder: "Enter email ID",
    type: "text",
    md: 4.5,
    isRequired: true,
  },
  {
    id: "movingOnDate",
    label: "Moving On",
    placeHolder: "Select",
    type: "date",
    md: 4.5,
    disablePast: true,
  },
  {
    id: "followUpDate",
    label: "Follow Up",
    placeHolder: "Select",
    type: "date",
    md: 4.5,
    // disablePast: true,
  },
];

export const clientConfirmationPaymentFields = [
  {
    label: "Payment :",
    type: "label",
    md: 1.5,
  },
  {
    id: "paymentMethod",
    label: "Payment Method",
    placeHolder: "",
    type: "select",
    md: 1.5,
    options: ["Debit", "Credit", "Cash"],
    // minRows:2,
    // inputProps: {
    //   maxLength: 1000,
    // },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "",
    label: "",
    type: "title",
    md: 9,
  },
  {
    label: "Content :",
    type: "label",
    md: 1.5,
  },
  {
    id: "contentValue",
    label: "Contents Value",
    placeHolder: "",
    type: "text",
    prefixIcon: "£",
    md: 1.5,
  },
  {
    id: "",
    label: "",
    type: "title",
    md: 1,
  },
];

export const clientConfirmationNoteFields = [
  {
    label: "Quote Notes",
    type: "title",
    md: 1.5,
  },
  {
    id: "notes",
    label: "Quote Notes (appears in confirmation)",
    placeHolder: "",
    type: "textarea",
    md: 10.5,
    minRows: 1,
    inputProps: {
      maxLength: 1000,
    },
     editReadOnly: true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "",
    label: "Confirmed On",
    type: "title",
    md: 1.5,
  },
  {
    id: "confirmedOn",
    label: "Confirmed On",
    placeHolder: "Select",
    type: "date",
    md: 3.5,
    disabled: true,
  },
   {
    label: "",
    type: "title",
    md: 6,
  },
   {
    label: "Accepted Status",
    type: "title",
    md: 1.5,
    isRequired:true
  },
  {
    id: "isQuoteAccepted",
    label: '',
    placeHolder: "",
    type: "checkbox",
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    
    // disabled: true,
    // inSingleGridForm: true,
  },
];
export const customerConfirmationNoteFields = [
  {
    id: "",
    label: "Customer Notes",
    type: "title",
    md: 1.5,
  },
  {
    id: "comments",
    label: "Customer Confirmation Notes",
    placeHolder: "",
    type: "textarea",
    md: 10.5,
    minRows: 1,
    inputProps: {
      maxLength: 1000,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];
export const clientConfirmationSelfNoteFields = [
  {
    id: "",
    label: "Notes",
    type: "title",
    md: 1.5,
  },
  {
    id: "confirmationNote",
    label: "Notes",
    placeHolder: "",
    type: "textarea",
    md: 10.5,
    minRows: 1,
    inputProps: {
      maxLength: 1000,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];

export const clientInsuranceGeneralFields = [
  {
    id: "insurancePercentage",
    label: "Insurance (%)",
    placeHolder: "",
    type: "text",
    md: 12,
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];
export const clientInsuranceFields = [
  {
    id: "insuranceAmount",
    label: "Insurance Amount",
    placeHolder: "",
    type: "text",
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    prefixIcon: "£",
    disabled: true,
    valueFormat: "number",
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "insuranceType",
    label: "Insurance Type",
    placeHolder: "",
    type: "text",
    options: [
      "Move Price",
      "Contents",
      "Pack Price",
      "In to store",
      "From store",
      "Fixed",
      "Bronze Ext Liability",
      "Silver Ext Liability",
      "Gold Ext Liability",
    ],
    md: 4,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
   {
    id: "isInsuranceAccepted",
    label: "Insurance Status",
    placeHolder: "Select",
    type: "radio",
    row: true,
    md: 4,
    radioOptions: [
      {
        label: "Accept",
        value: true,
      },
      {
        label: "Decline",
        value: false,
      },
      
    ],
  },
];


